<template>
  <v-card flat>
    <v-card-text>
      <div class="d-flex align-center gap-2">
        <v-icon
          color="success"
          size="20">
          circle
        </v-icon>
        <span class="green--text text--accent-4">
          เชื่อมต่อสำเร็จ
        </span>
        <v-spacer />
        <snt-confirm-dialog
          :title="`ยืนยันการ Log out หรือไม่?`"
          description="หากคุณกด Log out แล้ว ข้อมูลจะไม่เชื่อมต่อกับ PEAK อีก"
          content-width="300px"
          confirm-text="ยืนยัน"
          @confirm="logout()">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :loading="submitting"
              color="primary"
              outlined
              v-bind="attrs"
              v-on="on">
              Log out
            </v-btn>
          </template>
        </snt-confirm-dialog>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { UPDATE_SETTING } from '@/resources/graphql'

export default {
  data () {
    return {
      submitting: false
    }
  },
  methods: {
    logout () {
      this.submitting = true
      this.state = 'loading'
      this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            peakAccountToken: ''
          }
        }
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
